// extracted by mini-css-extract-plugin
export var actionButton = "_wu-2";
export var card = "_wu-0";
export var disambiguationList = "_wu-3";
export var errorCard = "_wu-4";
export var row = "_wu-1";